import { useState, useEffect } from 'react';

export interface DashboardStats {
  totalUsers: number;
  activeProjects: number;
  completedTasks: number;
  pendingTasks: number;
  usersChange: number;
  projectsChange: number;
  tasksChange: number;
}

interface UseDashboardStatsReturn {
  stats: DashboardStats;
  loading: boolean;
  error: string | null;
  refreshStats: () => Promise<void>;
}

export const useDashboardStats = (): UseDashboardStatsReturn => {
  const [stats, setStats] = useState<DashboardStats>({
    totalUsers: 0,
    activeProjects: 0,
    completedTasks: 0,
    pendingTasks: 0,
    usersChange: 0,
    projectsChange: 0,
    tasksChange: 0,
  });
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const fetchStats = async (): Promise<void> => {
    setLoading(true);
    setError(null);

    try {
      // Simulated API call - replace with actual API endpoint
      await new Promise((resolve) => setTimeout(resolve, 1000));

      // Mock data - replace with actual API response
      setStats({
        totalUsers: 1247,
        activeProjects: 32,
        completedTasks: 185,
        pendingTasks: 47,
        usersChange: 12.5,
        projectsChange: 8.3,
        tasksChange: 15.2,
      });
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Failed to fetch dashboard stats';
      setError(errorMessage);
      console.error('Error fetching dashboard stats:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStats();
  }, []);

  return {
    stats,
    loading,
    error,
    refreshStats: fetchStats,
  };
};
